import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

import { Vdd } from '@vi-iot/client';

import {
  DIAGNOSTICS_CONNECTION_STEP,
  InstallationDetailsStore,
  RemoteDiagnosticsSnapshotsStore,
  RemoteDiagnosticsStore,
  SnapshotType,
} from '@store';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-backup-vdd-table',
  templateUrl: './backup-vdd-table.component.html',
  styleUrls: ['./backup-vdd-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackupVddTableComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  private gatewaySerial: string;

  readonly snapshotTypeEnum = SnapshotType;
  readonly diagnosticsModalStep = DIAGNOSTICS_CONNECTION_STEP;

  installationId: number;
  isConnectionFailed = false;
  isActiveSessionAvailable: boolean;

  @Input() snapshotType: SnapshotType;
  @Input() fullWidthMode = false;
  @Input() isCreatingSnapshot = false;
  @Input() vdds: Vdd[];

  @Output() selectedVdd = new EventEmitter<Vdd>();

  constructor(
    public remoteDiagnosticsSnapshotsStore: RemoteDiagnosticsSnapshotsStore,
    public remoteDiagnosticsStore: RemoteDiagnosticsStore,
    private installationDetailsStore: InstallationDetailsStore,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((param) => {
      this.installationId = param['id'];
    });

    this.installationDetailsStore.gatewaySerial$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((serial) => {
        this.gatewaySerial = serial;
      });

    this.remoteDiagnosticsStore.getActiveConnectionStep$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((step) => {
        if (step === this.diagnosticsModalStep.CONNECTION_FAILED) {
          this.isConnectionFailed = true;
        }
        this.cdr.detectChanges();
      });

    this.remoteDiagnosticsStore
      .isActiveSessionAvailable(this.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isActiveSessionAvailable) => {
        this.isActiveSessionAvailable = isActiveSessionAvailable;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  readCurrentValues(): void {
    if (this.snapshotType === this.snapshotTypeEnum.SNAPSHOT) {
      this.remoteDiagnosticsSnapshotsStore.setInstallationVddList(this.vdds);
      this.remoteDiagnosticsSnapshotsStore.triggerReadVddListValuesForSnapshot(this.gatewaySerial);
    }
  }

  selectVdd(vdd: Vdd, event: MouseEvent): void {
    event.stopPropagation();
    this.selectedVdd.emit(vdd);
  }

  trackBy(_index: number, vdd: Vdd): string {
    return vdd.key;
  }

  isParameterInvalid(vdd: Vdd): Observable<boolean> | boolean {
    if (this.isCreatingSnapshot) {
      return this.remoteDiagnosticsSnapshotsStore.isSelectedSnapshotParameterInvalid(
        vdd.key,
        vdd.logicalLink
      );
    }

    return false;
  }
}
